import { FC, useCallback } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ProductFilter } from "../../../../components/filters/ProductFilter/ProductFilter";
import { COMPETITOR_UPLOAD_PROPS } from "../../../../components/filters/ProductFilter/constants";
import { ProductFilterValue } from "../../../../components/filters/ProductFilter/types";
import { useWorkspaceStore } from "../../../../store/workspace/WorkspaceStore";
import { Workspace } from "../../../../types/workspace";
import { areArraysEqualIgnoringOrder } from "../../../../utils/jsUtils";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import CopilotButton from "../../../../components/CopilotButton";
import {
  CopilotWorkflow,
  useCopilotStore,
} from "../../../../store/copilot/CopilotStore";

export const CompetitorsSelection: FC = () => {
  const products = useWorkspaceStore(
    (state) => state?.draft?.configuration?.competitorsProductIds || []
  );
  const setWorkspaceDraft = useWorkspaceStore((state) => state.setDraft);
  const highlightedElement = useCopilotStore(
    (state) => state.highlightedElement
  );

  const handleProductsSelect = useCallback(
    (productFilterValue: ProductFilterValue) => {
      if (areArraysEqualIgnoringOrder(productFilterValue.ids, products)) {
        return;
      }

      setWorkspaceDraft(
        (draft) =>
          ({
            ...draft,
            configuration: {
              ...(draft?.configuration || {}),
              competitorsProductIds: productFilterValue.ids,
            },
          }) as Workspace
      );
    },
    [products, setWorkspaceDraft]
  );

  const clearProducts = useCallback(() => {
    setWorkspaceDraft(
      (draft) =>
        ({
          ...draft,
          configuration: {
            ...(draft?.configuration || {}),
            competitorsProductIds: [],
          },
        }) as Workspace
    );
  }, [setWorkspaceDraft]);

  return (
    <Box height={425}>
      <Stack direction="row" justifyContent="space-between" marginBottom={2}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="subtitle1" fontWeight="medium">
            Competitors
          </Typography>
          <CopilotButton
            id="copilot-competitors-button"
            workflow={CopilotWorkflow.COMPETITIVE_ANALYSIS}
          />
        </Stack>
        <Button
          id="clear-competitors-button"
          variant="outlined"
          color="primary"
          size="small"
          onClick={clearProducts}
        >
          Clear
        </Button>
      </Stack>
      <Box>
        <ProductFilter
          selectedProductIds={products}
          onProductsSelect={handleProductsSelect}
          uploadProps={COMPETITOR_UPLOAD_PROPS}
          highlighted={highlightedElement === "competitor_input"}
        />
      </Box>
    </Box>
  );
};
